import { useQueryParams } from '@calendly/hooks'
import { parseQuery } from '@calendly/http-tools'
import { useMemo } from 'react'

import { useSettingsModalEmbedNavigation } from 'components/settings_modal_embed_context'

/**
 * Query params for pages rendered inside the settings modal memory router.
 * Filter/list state is stored on the browser URL; the memory router only carries tab paths.
 */
export const useSettingsModalQueryParams = () => {
  const routerParams = useQueryParams()
  const { embedded, browserLocation } = useSettingsModalEmbedNavigation()

  return useMemo(
    () => (embedded && browserLocation?.search
      ? parseQuery(browserLocation.search)
      : routerParams),
    [embedded, browserLocation?.search, routerParams],
  )
}
